import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('WAREHOUSES SERVICE');

@Injectable({
  providedIn: 'root'
})
export class WarehousesService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'warehouses' como el nombre del recurso a la clase base
    super('warehouses');
    log.debug('Servicio de Almacenes inicializado');
  }

}
